import { IconCircleCheck } from "../../assets/icons/icons";

export interface ButtonProps {
    title: string;
    onClick: () => void;
    toColor?: string;
    fromColor?: string;
    isLoading?: boolean;
    fromHoverColor?: string;
    toHoverColor?: string;
    icon?: any;
    className?: string;
}

export const DefaultButton = ({ title, onClick, toColor = "#8484F0", fromColor = "#5050EA", toHoverColor = "#7474E0", fromHoverColor = "#4040D0", isLoading = false, icon, className }: ButtonProps) => {
  const buttonStyle = {
    background: `linear-gradient(to right, ${fromColor}, ${toColor})`,
  };

  const hoverStyle = {
    background: `linear-gradient(to right, ${fromHoverColor}, ${toHoverColor})`,
  };

  return (
    <button
      onClick={onClick}
      disabled={isLoading}
      style={buttonStyle}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = hoverStyle.background;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = buttonStyle.background;
      }}
      className={`px-6 py-3 rounded-full text-sm font-medium transition-all duration-200 shadow-sm hover:shadow-md text-white cursor-pointer ${className}`}
    >
      {isLoading ? (
        <span className="flex items-center justify-center">
          <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          {title}
        </span>
      ) : (
        <div className="flex items-center justify-center space-x-2">
          <span>{title}</span>
          {icon || <IconCircleCheck color="white" width="20px" height="20px" />}
        </div>
      )}
    </button>
  );
};